import { createApi } from "@reduxjs/toolkit/query/react";

import type { CatalogDTO } from "../../../types/Catalog";
import { getBaseQuery } from "../baseQuery";

export const catalogService = createApi({
  reducerPath: "catalogService",
  baseQuery: getBaseQuery("orpheus"),
  tagTypes: ["Catalog"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getCatalogById: builder.query<CatalogDTO, { catalogId: string }>({
      query: (arg) => {
        const { catalogId } = arg;
        return {
          url: `/api/catalogs/${catalogId}`,
          method: "GET",
        };
      },
      providesTags: [{ type: "Catalog", id: "DETAIL" }],
    }),
  }),
});
export const { useGetCatalogByIdQuery } = catalogService;
